import { createSlice } from "@reduxjs/toolkit";
import { IconDTO, IconsLibraryJSON } from "../../models/Icon.model";
import { GetIcons, GetIconsLibrary } from "../thunks/iconThunks";

export interface IconState {
  icons: IconDTO[];
  libraryIcons: IconsLibraryJSON[]; // 🆕 הוספתי שדה לספריית האייקונים
  loading: boolean;
  error: string | null;
  initialized: boolean;
  lastCompanyKey: string | null; // 🆕 שמור את החברה האחרונה
  lastCategory: string | null; // 🆕 שמור את הקטגוריה האחרונה
}

const initialState: IconState = {
  icons: [],
  loading: false,
  error: null,
  initialized: false,
  lastCompanyKey: null,
  lastCategory: null,
  libraryIcons: [], // 🆕 הוספתי שדה לספריית האייקונים
};

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearIcons: (state) => {
      state.icons = [];
      state.initialized = false;
      state.error = null;
      state.lastCompanyKey = null;
      state.lastCategory = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetIcons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetIcons.fulfilled, (state, action) => {
        state.loading = false;
        state.icons = action.payload.icons;
        state.initialized = true;
        // 🆕 שמור את החברה והקטגוריה לזיהוי cache
        state.lastCompanyKey = action.meta.arg.companyKey;
        state.lastCategory = action.meta.arg.category;
      })
      .addCase(GetIcons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch icons";
      })
      .addCase(GetIconsLibrary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetIconsLibrary.fulfilled, (state, action) => {
        state.loading = false;
        state.libraryIcons = [
          ...state.libraryIcons,
          action.payload.iconsLibraryJSON,
        ]; // 🆕 הוספת ספריית האייקונים למערך
      })
      .addCase(GetIconsLibrary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch icons library";
      });
  },
});

export const { clearError, clearIcons } = activitySlice.actions;
export default activitySlice.reducer;
